import OrdersRequests from '../../server/orders';
import { addLoading, removeLoading } from './loading';

export const setOrders = orders => ({
  type: 'GET_ORDERS_PANEL',
  orders,
});

export const cancelOrderId = orderId => ({
  type: 'CANCEL_ORDER',
  orderId,
});

const getOrders = (limit, skip, search = '', order = '', field = '', filter = '', initialDate = '', finalDate = '') => async (dispatch) => {
  if (!search) dispatch(addLoading());
  try {
    const orderRes = await OrdersRequests.getOrders(limit, skip, search, order, field, filter, initialDate, finalDate);
    dispatch(setOrders(orderRes));
  } finally {
    if (!search) dispatch(removeLoading());
  }
};

const getOrderProcess = id => async (dispatch) => {
  dispatch(addLoading());
  try {
    return OrdersRequests.getOrderProcess(id);
  } finally {
    dispatch(removeLoading());
  }
};

const getPurchaseItems = purchaseId => async (dispatch) => {
  dispatch(addLoading());
  try {
    return OrdersRequests.getPurchaseItems(purchaseId);
  } finally {
    dispatch(removeLoading());
  }
};

const cancelOrder = orderId => async (dispatch) => {
  dispatch(addLoading());
  try {
    await OrdersRequests.cancelOrder(orderId);
    dispatch(cancelOrderId(orderId));
  } finally {
    dispatch(removeLoading());
  }
};

const downloadOrderCsv = (initialDate, finalDate) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await OrdersRequests.downloadOrderCsv(initialDate, finalDate);
  } finally {
    dispatch(removeLoading());
  }
};

const downloadPendingOrders = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await OrdersRequests.downloadPendingOrders();
  } finally {
    dispatch(removeLoading());
  }
};

export default {
  getOrders,
  cancelOrder,
  getOrderProcess,
  downloadOrderCsv,
  downloadPendingOrders,
  getPurchaseItems,
};
